module.exports = __webpack_public_path__ + "media/images/new-ui-images/notification-edge-9016a07627db29a50e077bc2135effa1.svg";